export function createSnowEffect() {
  const stars = ["⭐", "🌟", "✨", "💫", "⚡"]
  const particleCount = 50

  for (let i = 0; i < particleCount; i++) {
    const particle = document.createElement("div")
    particle.className = "snow-particle"
    particle.textContent = stars[Math.floor(Math.random() * stars.length)]

    // Randomize position and animation
    const startPosition = Math.random() * window.innerWidth
    const size = Math.random() * 15 + 8 // Slightly smaller size range for stars
    const duration = Math.random() * 2 + 1 // Faster fall for a more magical effect
    const delay = Math.random() * 0.5

    particle.style.left = `${startPosition}px`
    particle.style.fontSize = `${size}px`
    particle.style.animationDuration = `${duration}s`
    particle.style.animationDelay = `${delay}s`

    document.body.appendChild(particle)

    // Clean up particle after animation
    setTimeout(() => {
      document.body.removeChild(particle)
    }, (duration + delay) * 1000)
  }
}
